module.exports = __webpack_public_path__ + "static/media/L.d51509c1.jpg";